import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, signal, WritableSignal } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';

import { Incident } from 'src/app/api/incidents.service';
import { LinkableLocationsService, ProfileLocation } from 'src/app/api/linkable-locations.service';
import { WorkflowPriority, WorkflowService } from 'src/app/api/workflow.service';

@Component({
    selector: 'app-incident-form',
    templateUrl: './incident-form.component.html',
    styleUrls: ['./incident-form.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IncidentFormComponent implements OnInit {


  private incidentWorkflowId = 1; //Hard code for now


  @Output()
  submit = new EventEmitter<Partial<Incident>>();
  
  editMode = signal(false);

  priorities: WritableSignal<WorkflowPriority[]> = signal([]);
  locations: WritableSignal<ProfileLocation[]> = signal([]);


  @Input()
  set incident(incident: Incident) {
    this.editMode.set(true);
    this.incidentForm = this.fb.group({
      summary: [incident.summary, Validators.required],
      description: [incident.description],
      startDate: [incident.startDate, Validators.required],
      priorityId: [incident.priorityId, Validators.required],
      locationId: [incident.locationId]
    })
  }

  incidentForm: UntypedFormGroup = this.fb.group({
    summary: ['', Validators.required],
    description: [''],
    startDate: ['', Validators.required],
    priorityId: [-1, [Validators.required, Validators.min(1)]],
    locationId: [null]

  })

  constructor(
    private fb: UntypedFormBuilder,
    private workflowService: WorkflowService,
    private linkableLocationService: LinkableLocationsService
  ) { }


  ngOnInit(): void {
    this.workflowService.getPrioritiesForWorkflow(this.incidentWorkflowId).subscribe((priorities) => {
      this.priorities.set( [{name: "Select...", priorityId: 0, icon: "", order: 0, workflowId: -1, workflowPriorityId: -1},...priorities]);
    })

    this.linkableLocationService.getLocations("active").subscribe((locations) => {
      this.locations.set(locations);
    })
  }

  onSubmit() {
    const incident = this.incidentForm.value;

    //convert priority to number
    incident.priorityId = Number.parseInt(incident.priorityId);
    
    this.submit.emit(incident);
  }

  getFormControl(name: string) {
    return this.incidentForm.get(name);
  }

}
